import { action, computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

export class LevelSetting extends DTO {
  difficultySetting: [number, number, number, number, number]
  key: 'veryLow' | 'low' | 'middle' | 'high' | 'veryHigh'

  constructor(key, difficultySetting) {
    super()
    makeObservable(this, {
      key: observable,
      difficultySetting: observable,
      isValid: computed,
      total: computed,
      updateNumber: action,
    })

    this.difficultySetting = difficultySetting
    this.key = key
  }

  get total() {
    return this.difficultySetting.reduce((prev, cur) => prev + cur)
  }

  get isValid() {
    return 100 === this.total
  }

  updateNumber = (index: number, value: string) => {
    const isNumeric = /^\d*$/.test(value)
    if (!isNumeric) return
    const numberValue = Number(value)

    const difficultySetting = this.difficultySetting
    difficultySetting[index] = numberValue
    this.difficultySetting = difficultySetting
  }
}
